import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Card,
  CardHeader,
  CardBody,
  Table,
  CustomInput,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import Swal from "sweetalert2";
import TableScrollbar from "react-table-scrollbar";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import { getUserLocations } from "../../../store/Mini/actions";
import {
  SelecteChangeValue,
  getPOList,
  AddPOdata,
  InputChangeValue,
  IGPAdd,
  IGPItemSelect,
  getPOItemsList,
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  SetParams,
  PreviewImage,
  UploadImage,
  //------
  poItemsModel_close,
  IGPAddPOdata,
} from "../../../store/ingatepass/actions";

class POItemsModel extends Component {
  constructor(props) {
    super(props);
    this.state = { imagePreviewUrl: null, POBillImgFile: null };
    this.ChangeHandeler = this.ChangeHandeler.bind(this);

    // this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }
  componentDidMount() {}
  // getCheckedRequest(e, item, index) {
  //   this.props.IGPItemSelect(e.target.checked, item, index);
  // }
  ItemChangeHandeler(e, item) {
    this.props.ItemQtyChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
      status: "DeptHod",
    });
  }
  ChangeHandeler(e) {
    this.props.InputChangeValue({
      key: e.target.name,
      value: e.target.value,
    });
  }
  UploadImage() {
    var that = this;
    if (this.props.IGPcheckedItem.length !== 0) {
      if (this.props.previewImage !== null) {
        this.props.UploadImage(
          "POBillImg",
          this.props.previewImage,
          function (sucess, response) {
            if (sucess) {
              try {
                that.handleValidSubmit(response);
              } catch (error) {}
            } else {
              Swal.fire({
                icon: "error",
                title: "Image Upload Failed",
              });
            }
          }
        );
      } else {
        this.handleValidSubmit({});
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Select Any Item and Enter Qty",
      });
    }
  }
  handleValidSubmit(imageData) {
    // var grn2items = [];
    // this.props.IGPcheckedItem.map((p) => {

    // var igpitem = {
    //   // id: p.id,
    //   product_id: p.product.id,
    //   qty: p.t_qty ? p.t_qty : p.availableqty,
    //   unit_id: p.t_unit ? p.t_unit.id : p.product?.baseunit.id,
    //   unit_name: p.t_unit ? p.t_unit.name : p.product?.baseunit.name,
    //   tax_id: p.tax.id,
    //   taxtype: p.taxtype,
    //   poitem_id: p.id,
    //   make: p.make,
    //   description: p.description,
    //   dodelete: p.dodelete,
    //   purchaseorder_id: p.purchaseorder_id,
    // };
    //   grn2items.push(igpitem);

    //   return 0;
    // });

    var data = {
      location_id: this.props.userLocation[0].id,
      purchaseorder_id: this.props.poData.id,
      purchaseorder_code: this.props.poData.code,
      description: this.props.PORowData.description,
      vendor_id: this.props.poData.vendor.id,
      Vendor_name: this.props.poData.vendor.name,
      grn2items: this.props.IGPcheckedItem,
      bill_image: imageData?.file,
      bill_image_id: imageData?.id,
    };

    this.props.IGPAddPOdata(data);
    this.props.getPOList();
    this.addForm && this.addForm.reset();
    // this.props.IGPAdd(data, this.props.match.params.id, this.props.history);
    this.setState({
      imagePreviewUrl: null,
      // POBillImgFile: null,
    });
  }

  handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    // var url = reader.readAsDataURL(file);
    this.props.PreviewImage(e.target.files[0]);
    reader.onloadend = () => {
      this.setState({
        imagePreviewUrl: reader.result,
        // POBillImgFile: file,
      });
    };
    if (e.target.files.length !== 0) {
      reader.readAsDataURL(file);
    } else {
      this.props.PreviewImage({});

      this.setState({
        imagePreviewUrl: null,
        // POBillImgFile: null,
      });
    }
  }
  render() {
    let { imagePreviewUrl } = this.state;
    let $imagePreview = null;

    if (imagePreviewUrl) {
      $imagePreview = (
        <img
          className="product-img"
          alt="User"
          src={imagePreviewUrl}
          style={{
            height: "150px",
            width: "250px",
            cursor: "pointer",
          }}
        />
      );
    } else if (this.props.PORowData?.bill_image) {
      $imagePreview = (
        <img
          className="product-img"
          alt="User"
          src={
            this.props.PORowData?.bill_image
              ? this.props.PORowData?.bill_image
              : DefaultImg
          }
          style={{
            height: "150px",
            width: "250px",
            cursor: "pointer",
          }}
        />
      );
    } else {
      $imagePreview = (
        <div
          className="img-thumbnail text-center W-100 pt-2 "
          style={{
            height: "150px",
            width: "250px",
            cursor: "pointer",
          }}
        >
          <i className="ri-upload-cloud-line ri-4x"></i>
          <br />
          <span className="font-size-16">Select PO Bill</span>
        </div>
      );
    }
    return (
      <React.Fragment>
        <Modal
          isOpen={this.props.poItemsModel}
          backdrop="static"
          centered
          size="xl"
        >
          <ModalHeader
            toggle={() => {
              this.props.poItemsModel_close();
              this.addForm && this.addForm.reset();
            }}
          >
            PO ({this.props.poData.code})
          </ModalHeader>
          <AvForm
            className="form-horizontal"
            // onValidSubmit={this.handleValidSubmit}
            ref={(c) => (this.addForm = c)}
          >
            <ModalBody>
              <Card className="pt-1">
                <CardHeader className="bg-transparent border-bottom">
                  <div className="list-column">
                    <Row>
                      <Col md={6}>
                        <ul className="list-style-two p-0">
                          <li className="clearfix">
                            <span className="ttl">Vendor Name: </span>
                            <span className="dtl">
                              {this.props.poData.vendor?.name}
                            </span>
                          </li>
                          <li className="clearfix">
                            <span className="ttl">Gross Value:</span>
                            <span className="dtl">
                              &#8377; {this.props.poData.total}
                            </span>
                          </li>
                        </ul>
                      </Col>
                      <Col md={6}>
                        <ul className="list-style-two p-0">
                          <li className="clearfix">
                            <span className="ttl">RFQ Code: </span>
                            <span className="dtl">
                              {this.props.poData.requestforquotation_code}
                            </span>
                          </li>
                          <li className="clearfix">
                            <span className="ttl">PO Code:</span>
                            <span className="dtl">
                              {this.props.poData.code}
                            </span>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </CardHeader>
                <CardBody className="p-0">
                  <div className="table-responsive m-1">
                    <TableScrollbar height="400px">
                      <Table className="mb-0 p-1 table-centered">
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="">Action</th>
                            <th className="">Item Image</th>
                            <th className="">Items Name</th>
                            <th className="">PO Quantity</th>
                            <th className="">Balance Quantity</th>
                            <th className="">Received Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.poItemsList.length !== 0 ? (
                            <>
                              {this.props.filterPOData.length === 0 ? (
                                <>
                                  <tr>
                                    <td colSpan={9} className="text-center">
                                      <div>
                                        <span className="font-size-18 text-danger">
                                          All Items are Received
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              ) : (
                                <>
                                  {this.props.filterPOData?.map((item, key) => (
                                    <>
                                      <tr key={key}>
                                        <td className="nowrap text-center">
                                          <CustomInput
                                            type="checkbox"
                                            name="MRlistItem"
                                            id={"mRitemscheck" + key}
                                            checked={item.itemcheck}
                                            disabled={
                                              item.product.active === true
                                                ? false
                                                : true
                                            }
                                            onChange={(e) => {
                                              this.props.IGPItemSelect(
                                                e.target.checked,
                                                item,
                                                key
                                              );
                                            }}
                                          />
                                          {/* )}
                                            {item.mrstatus !==
                                              3 && (
                                              <CustomInput
                                                type="checkbox"
                                                name="MRlistItem"
                                                id={
                                                  "mRitemscheck" +
                                                  key
                                                }
                                                checked={true}
                                                disabled={true}
                                              />
                                            )} */}
                                        </td>
                                        <td className="nowrap text-center">
                                          <div className="product-detail text-center">
                                            <img
                                              src={
                                                item?.product?.image == null
                                                  ? DefaultImg
                                                  : item?.product?.image
                                              }
                                              alt="product-img"
                                              title="product-img"
                                              className="product-img  img-fluid mx-auto tab-img rounded"
                                              style={{
                                                height: "100px",
                                                width: "150px",
                                              }}
                                            />
                                          </div>
                                        </td>
                                        <td className="nowrap ">
                                          <h5 className="font-size-14 ">
                                            {item.product.name}
                                          </h5>
                                          <p className="mb-0">
                                            Make :
                                            <span className="font-weight-medium">
                                              {item.make}
                                            </span>
                                          </p>
                                          <p className="mb-0">
                                            Description :
                                            <span className="font-weight-medium">
                                              {item.description}
                                            </span>
                                          </p>
                                          {item.poi_acknowledges.length !==
                                            0 && (
                                            <>
                                              <p className="mb-0">
                                                <b className="text-danger">
                                                  Acknowledge:
                                                </b>
                                                <span className="font-weight-medium">
                                                  {
                                                    item.poi_acknowledges[0]
                                                      .description
                                                  }
                                                </span>
                                              </p>
                                              <p className="mb-0">
                                                <b className="text-danger">
                                                  Acknowledge By :
                                                </b>
                                                <span className="font-weight-medium">
                                                  {
                                                    item.poi_acknowledges[0]
                                                      .createdby.fullname
                                                  }
                                                  (
                                                  {
                                                    item.poi_acknowledges[0]
                                                      .createdby.username
                                                  }
                                                  )
                                                </span>
                                              </p>
                                            </>
                                          )}
                                        </td>
                                        <td className="nowrap text-center">
                                          {item.qty} {item.unit.name}
                                        </td>
                                        <td className="nowrap text-center">
                                          {item.availableqty}{" "}
                                          {item.product?.baseunit.name}
                                        </td>
                                        <td
                                          style={{
                                            minWidth: "220px",
                                          }}
                                          className="nowrap text-center"
                                        >
                                          {item.itemcheck ? (
                                            <>
                                              <FormGroup row className="mb-0">
                                                <Col xs={3} sm={3} md={3}>
                                                  <Label
                                                    htmlFor="Qty"
                                                    className="col-form-label float-left"
                                                  >
                                                    Qty :
                                                  </Label>
                                                </Col>
                                                <Col xs={9} sm={9} md={9}>
                                                  <AvField
                                                    placeholder="Quantity"
                                                    className="pr-0 form-control"
                                                    min={0}
                                                    disabled={
                                                      item.itemcheck
                                                        ? false
                                                        : true
                                                    }
                                                    // max={100}
                                                    type="number"
                                                    // step="1"
                                                    name={key + "qty"}
                                                    id="qty"
                                                    value={
                                                      item.itemcheck
                                                        ? item.t_qty
                                                        : ""
                                                    }
                                                    validate={{
                                                      required: {
                                                        value: item.itemcheck
                                                          ? true
                                                          : false,
                                                        errorMessage:
                                                          "Please enter Qty",
                                                      },
                                                      pattern: {
                                                        value:
                                                          "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                        errorMessage:
                                                          "Qty can compose numbers and 3 decimals ",
                                                      },
                                                    }}
                                                    onChange={(e) =>
                                                      this.ItemChangeHandeler(
                                                        e,
                                                        item
                                                      )
                                                    }
                                                  />
                                                </Col>
                                              </FormGroup>
                                              <FormGroup row className="mb-0">
                                                <Col xs={3} sm={3} md={3}>
                                                  <Label
                                                    htmlFor="Units"
                                                    className="col-form-label float-left"
                                                  >
                                                    Units :
                                                  </Label>
                                                </Col>
                                                <Col xs={9} sm={9} md={9}>
                                                  <Select
                                                    id="units_select"
                                                    name="units_select"
                                                    required="required"
                                                    options={item?.product?.units?.map(
                                                      (i) => ({
                                                        label: i.name,
                                                        value: i.id,
                                                      })
                                                    )}
                                                    isDisabled={
                                                      item.itemcheck
                                                        ? false
                                                        : true
                                                    }
                                                    value={{
                                                      label: item.t_unit.name,

                                                      value: item.checked
                                                        ? item.t_unit.id
                                                        : "Select Units",
                                                    }}
                                                    onChange={(e) => {
                                                      this.props.ItemUnitsChangeValue(
                                                        {
                                                          label: e.label,
                                                          value: e.value,
                                                          item,
                                                          status: "DeptHod",
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </Col>
                                              </FormGroup>
                                            </>
                                          ) : (
                                            <Button
                                              type="button"
                                              color="primary"
                                              className="waves-effect waves-light"
                                              onClick={() => {
                                                this.props.IGPItemSelect(
                                                  !item.itemcheck,
                                                  item,
                                                  key
                                                );
                                              }}
                                            >
                                              <i className="mdi mdi-plus"></i>{" "}
                                              Add
                                            </Button>
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))}
                                </>
                              )}
                            </>
                          ) : (
                            <tr>
                              <td colSpan={9} className="text-center">
                                <div>
                                  <span className="font-size-18 text-danger">
                                    Data not available
                                  </span>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </TableScrollbar>
                  </div>
                </CardBody>
              </Card>

              <Card className="p-0 ">
                <CardHeader className="bg-transparent border-bottom p-1">
                  <Row>
                    <Col md={8}>
                      <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>
                      <h5 className="card-title-15 d-inline-block">
                        Other Details
                      </h5>
                    </Col>
                    <Col md={4}>
                      <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>
                      <h5 className="card-title-15 d-inline-block">PO Bill</h5>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="p-2 ">
                  <Row>
                    <Col md={8}>
                      <div>
                        <FormGroup className="mb-0  ">
                          <AvField
                            name="description"
                            id="description"
                            type="textarea"
                            className="form-control"
                            placeholder="Enter Details"
                            value={
                              this.props.PORowData.description == null
                                ? ""
                                : this.props.PORowData.description
                            }
                            required
                            rows="7"
                            onChange={this.ChangeHandeler}
                          />
                        </FormGroup>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="product-detail">
                        <div className="mt-2 align-items-center ">
                          <label htmlFor="productCustomFile">
                            {/* <div className="img-icon">
                                        <i className="ri-camera-fill "></i>
                                      </div> */}

                            {$imagePreview}
                          </label>
                          <span className="text-danger mt-0">
                            {this.props.error_msg?.image}
                          </span>
                          <div
                            className="d-inline-block"
                            style={{
                              width: "250px",
                            }}
                          >
                            <CustomInput
                              type="file"
                              className="file-upload"
                              id="productCustomFile"
                              accept="image/*"
                              multiple={false}
                              onChange={(e) => this.handleImageChange(e)}
                              validate={{
                                required: { value: true },
                                // pattern: { value: "^[A-Za-z0-9]+$" },
                                // minLength: { value: 6 },
                                // maxLength: { value: 16 },
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              <ModalFooter>
                <Button
                  type="button"
                  className="btn btn-danger"
                  color="light"
                  onClick={() => {
                    this.props.poItemsModel_close();
                    this.addForm && this.addForm.reset();
                    this.setState({
                      imagePreviewUrl: null,
                    });
                  }}
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="btn btn-primary"
                  color="primary"
                  onClick={() => this.UploadImage()}
                >
                  Save
                </Button>
              </ModalFooter>
            </ModalBody>
          </AvForm>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { vendorslist, userLocation } = state.Mini;
  const {
    poItemsModel,
    IGPPOData,
    //------------
    PORowData,
    poList,

    igpitems,
    poData,
    poItemsList,
    itemSelectedId,
    params,
    loading,
    IGPcheckedItem,
    filterPOData,
    previewImage,
  } = state.ingatepass;

  return {
    poItemsModel,
    IGPPOData,
    vendorslist,
    userLocation,

    poList,
    PORowData,
    igpitems,
    poData,
    poItemsList,
    itemSelectedId,
    params,
    loading,
    IGPcheckedItem,
    filterPOData,
    previewImage,
  };
};

export default connect(mapStatetoProps, {
  SelecteChangeValue,

  getPOList,
  AddPOdata,
  InputChangeValue,
  IGPAdd,
  getUserLocations,
  IGPItemSelect,
  getPOItemsList,
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  SetParams,
  poItemsModel_close,
  IGPAddPOdata,
  PreviewImage,
  UploadImage,
})(POItemsModel);
